import { type MetaDescriptor } from 'react-router'
import { type Artwork } from '../../../types/art.types'
import {
  type FRAME_COLORS,
  type MATERIAL_TYPES,
  type TILE_SIZES,
} from '@mixtiles/web-backend-shared'
import type { PricingItem } from '../../../components/Pricing/types/pricingItem.types'

export interface ProductRouteParams {
  size?: string
  material?: string
  language?: string
  forceCountry?: string
  sku?: string
  [key: string]: string | undefined
}

export enum ProductRouteType {
  PHOTOTILES = 'phototiles',
  CANVAS = 'canvas',
  PHOTOBOOKS = 'photobooks',
  ART = 'art',
}

export enum PhotoBookTheme {
  WEDDING = 'wedding',
  MEMORY = 'memory',
  SMALL = 'small',
  BOUDOIR = 'boudoir',
  TRAVEL = 'travel',
  COFFEE_TABLE = 'coffee-table',
  ENGAGEMENT = 'engagement',
  FAMILY = 'family',
  ANNIVERSARY = 'anniversary',
  PET_DOG = 'pet-dog',
  MOTHERS_DAY = 'mothers-day',
  CHRISTMAS = 'christmas',
  FATHERS_DAY = 'fathers-day',
  RETIREMENT = 'retirement',
  BIRTHDAY = 'birthday',
  GRADUATION = 'graduation',
  YEARLY = 'yearly',
  VALENTINES = 'valentines',
  RECIPE = 'recipe',
  DEALS = 'deals',
  DESIGNED_COVERS = 'designed-covers',
  BABY = 'baby',
  WEDDING_DESIGNED_COVERS = 'wedding-designed-covers',
  BABY_DESIGNED_COVERS = 'baby-designed-covers',
  BIRTHDAY_DESIGNED_COVERS = 'birthday-designed-covers',
  COFFEE_TABLE_DESIGNED_COVERS = 'coffee-table-designed-covers',
  PROPOSAL_DESIGNED_COVERS = 'proposal-designed-covers',
  CHRISTMAS_DESIGNED_COVERS = 'christmas-designed-covers',
  FAMILY_DESIGNED_COVERS = 'family-designed-covers',
  SCHOOL_YEARS_DESIGNED_COVERS = 'school-years-designed-covers',
}

export interface SeoData {
  title: string
  h1: string
  description: string
  noIndex?: boolean
  canonicalPath?: string
}

export interface SeoConfigItem extends SeoData {
  params?: Record<string, string>
}

export interface SeoMetaData {
  seoData?: SeoData | null
  fallbackDescription?: string
  locale: string
}

export type ProductMetaArgs = {
  loaderData?: {
    locale: string
    pathname: string
    variant?: string
    artwork?: Artwork
    [key: string]: unknown
  } & SeoMetaData
  location: {
    pathname: string
    search: string
    hash: string
    state: unknown
    key: string
  }
  matches: Array<{
    id: string
    pathname: string
    params: Record<string, string | undefined>
    loaderData: unknown
    meta?: MetaDescriptor[]
  }>
}

export interface TileVariantOptions {
  isArt?: boolean
  isCanvas?: boolean
}

export interface ExtractTileDataResult {
  material: MATERIAL_TYPES
  color: FRAME_COLORS
  size: TILE_SIZES
  title: string
  pricingItem?: PricingItem
}
